"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BarChartWithCustomizedEvent = void 0;
var _recharts = require("recharts");
var _react = _interopRequireWildcard(require("react"));
var _formatGraphPrice = require("../../utils/formatGraphPrice");
var _react2 = require("@emotion/react");
var _styles = require("./styles");
var _CustomLegend = require("../../shared/recharts/CustomLegend");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BarChartWithCustomizedEvent = ({
  height = '300px',
  width = 'auto',
  data = [],
  bars,
  selectedIndex,
  xAxisDataKey,
  yAxisDataKey,
  xAxisLine = false,
  yAxisLine = false,
  tickLineX = false,
  tickLineY = false,
  legendHAlign = 'left',
  legendVAlign = 'bottom',
  margin,
  legendPadding,
  legend = false,
  layout = 'horizontal',
  onClickBar,
  tickFormatterX = e => e,
  tickFormatterY,
  ...rest
}) => {
  const theme = (0, _react2.useTheme)();
  const [hoverIndex, setHoverIndex] = (0, _react.useState)(undefined);
  const handleBarClick = (_, index) => {
    const identicalIndex = index === selectedIndex;
    if (onClickBar && !identicalIndex) {
      onClickBar({
        data: data[index],
        index: index
      });
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CustomEventBarChartContainer, {
    width: width && width,
    height: height && height,
    theme: theme,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.ResponsiveContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_recharts.BarChart, {
        data: data && data,
        margin: margin ? margin : {
          top: 0,
          right: 0,
          left: 0,
          bottom: 0
        },
        barGap: "0%",
        layout: layout && layout,
        ...rest,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.CartesianGrid, {
          strokeDasharray: "0",
          vertical: false
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.XAxis, {
          dataKey: xAxisDataKey && xAxisDataKey,
          axisLine: xAxisLine && xAxisLine,
          tickLine: tickLineX && tickLineX,
          type: layout === 'vertical' ? 'number' : 'category',
          tickFormatter: tickFormatterX,
          tickMargin: 5
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.YAxis, {
          dataKey: yAxisDataKey && yAxisDataKey,
          axisLine: yAxisLine && yAxisLine,
          tickLine: tickLineY && tickLineY,
          type: layout === 'vertical' ? 'category' : 'number',
          tickFormatter: tickFormatterY ? tickFormatterY : _formatGraphPrice.formatAxisPrice
        }), legend && /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Legend, {
          verticalAlign: legendVAlign && legendVAlign,
          align: legendHAlign && legendHAlign,
          content: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomLegend.CustomLegend, {}),
          wrapperStyle: {
            paddingLeft: legendPadding?.left ? legendPadding.left : '55px',
            paddingTop: legendPadding?.top ? legendPadding.top : '10px',
            paddingBottom: legendPadding?.bottom ? legendPadding.bottom : '0',
            paddingRight: legendPadding?.right ? legendPadding.right : '0'
          }
        }), bars?.length && bars.map(bar => {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Bar, {
            dataKey: bar.dataKey,
            fill: bar.fill,
            name: bar.name,
            maxBarSize: 50,
            onClick: handleBarClick,
            stackId: "stack",
            children: data?.length && data.map((_, index) => {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Cell, {
                cursor: "pointer",
                fill: bar.fill,
                onMouseEnter: () => setHoverIndex(index),
                onMouseLeave: () => setHoverIndex(undefined),
                className: `bar-cell ${index === selectedIndex && 'bar-cell-selected'} ${index === hoverIndex && 'bar-cell-hovered'}`
              }, `cell-${index}`);
            })
          }, bar.name);
        })]
      })
    })
  });
};
exports.BarChartWithCustomizedEvent = BarChartWithCustomizedEvent;
var _default = exports.default = BarChartWithCustomizedEvent;